import { ArrowForwardIcon } from '@traceair/webapp-icons';
import {
  DatePicker,
  DatePickerItem,
  Gray10,
  Gray120,
  Gray70,
  IDatePickerItemProps,
  typeBase10MediumCapsProperties,
  typeCompact17MediumProperties,
} from '@traceair/tds';
import { classes, style, stylesheet } from 'typestyle';
import { ScheduledFlight } from '../../../../types';
import { format as formatWithFns } from 'date-fns';
import dayjs, { Dayjs } from 'dayjs';
import { Dispatch, SetStateAction } from 'react';

const css = stylesheet({
  calendar: {
    display: 'grid',
    gridTemplateColumns: '80px 24px 1fr',
    columnGap: 6,
    rowGap: 4,
    marginBottom: 24,
    alignItems: 'center',
  },
  heading: {
    ...typeBase10MediumCapsProperties,
    color: Gray120,
  },
  headingPadded: {
    paddingLeft: 12,
  },
  currentDate: {
    ...typeCompact17MediumProperties,
    textDecoration: 'line-through',
  },
});

interface Props {
  schedule?: ScheduledFlight;
  newDate?: Dayjs;
  setNewDate: Dispatch<SetStateAction<Dayjs | undefined>>;
  availableGreenDays: string[];
}

const HighlightedDate = (props: IDatePickerItemProps) => (
  <DatePickerItem
    {...props}
    customStyles={{
      cell: {
        disabled: style({ background: Gray10 }),
      },
    }}
  />
);

export const DateChangeMissionCalendar = ({ schedule, newDate, setNewDate, availableGreenDays }: Props) => {
  if (!schedule) return null;

  const date = new Date(schedule.flightDateIso);
  const defaultViewDate = dayjs(date);
  const currentDate = formatWithFns(date, 'MM/dd/yy');

  const allowDates = (day: Dayjs) => {
    return availableGreenDays.includes(day.format('YYYY-MM-DD'));
  };

  return (
    <div className={css.calendar}>
      <div className={css.heading}>Mission Date</div>
      <div />
      <div className={classes(css.heading, css.headingPadded)}>New Date</div>

      <div className={css.currentDate}>{currentDate}</div>
      <div>
        <ArrowForwardIcon color={Gray70} />
      </div>
      <div>
        <DatePicker
          cellComponent={(cellDate: Dayjs) => {
            return date.toLocaleDateString() === cellDate.toDate().toLocaleDateString() ? HighlightedDate : undefined;
          }}
          defaultViewDate={defaultViewDate}
          allowDates={allowDates}
          value={newDate}
          onChange={setNewDate}
        />
      </div>
    </div>
  );
};
